// extracted by mini-css-extract-plugin
module.exports = {"panel":"Index_panel__22mTm","time":"Index_time__3th3a","inside-divider":"Index_inside-divider__DPSCp","avatar":"Index_avatar__2AfVJ","divider":"Index_divider__35yPf"};